export function getVersion(): string {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const packages = require('../package.json');
    return `web_${packages.version}`;
}
